import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth-service';
import { UserRole } from '../../models/user';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home-component',
  imports: [CommonModule, RouterModule],
  templateUrl: './home-component.html',
  styleUrl: './home-component.css',
})
export class HomeComponent {
  auth = inject(AuthService);
  readonly userRole = UserRole;

  enterAs(role: UserRole): void {
    this.auth.enterAs(role);
  }

  getRoleLabel(role: UserRole): string {
    switch (role) {
      case UserRole.Admin:
        return 'Admin';
      case UserRole.DungeonMaster:
        return 'Dungeon Master';
      case UserRole.Player:
        return 'Player';
      default:
        return role;
    }
  }
}
